import {VIDEO_CATEGORY} from '../defines/protocol';
import {IsEmptyVar, Txt2Date} from '../defines/common.func';
import {GetRegionByName, GetSubRegionByText, REGION} from '../defines/gukeo.const';

export class Video {
  no: number;
  title: string;
  youtubeId: string;
  category: VIDEO_CATEGORY;
  bookmark: boolean;
  area1: string;
  area2: string;
  new: boolean;
  lastModified?: Date;
  registered?: Date;

  constructor(obj?: any) {
    this.no               = obj?.no             ?? null;
    this.title            = obj?.title          ?? null;
    this.youtubeId        = obj?.youtube_id     ?? null;
    this.category         = obj?.category       ?? null;
    this.bookmark         = obj?.bookmark       ? !!obj.bookmark : false;
    this.area1            = obj?.area1          ?? null;
    this.area2            = obj?.area2          ?? null;
    this.new              = obj?.new            ? !!obj.new : false;

    if (obj?.last_modified) {
      this.lastModified = Txt2Date(obj.last_modified);
    }
    if (obj?.registered) {
      this.registered = Txt2Date(obj.registered);
    }
  }
}


export class VideoStory {
  no: number;
  title: string;
  image?: string;
  regions?: number;

  constructor(obj?: any) {
    this.no               = obj?.no             ?? null;
    this.title            = obj?.title          ?? null;
    this.image            = obj?.image          ?? null;
    this.regions          = obj?.regions        ?? null;
  }
}
